export function createCustomSizeBlob(sizeInBytes : number, type: string) {
    const data = new Uint8Array(sizeInBytes); // Create an array with the desired size
    for (let i = 0; i < sizeInBytes; i++) {
        data[i] = 0; // You can initialize the data with any value you want
    }

    return new Blob([data], { type: type });
}
